const storeStockModal = document.querySelector(".store-stock__modal");

function openStockModal() {
  if (!storeStockModal) return;

  storeStockModal.classList.add("is-active");
}
function closeStockModal() {
  if (!storeStockModal) return;

  storeStockModal.classList.remove("is-active");
}

function filterItems(checked) {
  if (!storeStockModal) return;

  const stockists = storeStockModal.querySelectorAll(".store-item");

  if (!stockists) return;

  stockists.forEach((item) => {
    const status = item.querySelector(".stock-label");
    if (!status) return;

    if (checked) {
      if (status.classList.contains("in-stock")) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    } else {
      item.style.display = "block";
    }
  });
}

(function () {
  const filterCheckbox = document.querySelector("[data-store-filter]");

  if (filterCheckbox) {
    filterCheckbox.addEventListener("change", (e) => {
      // filterItems(e);
    });
  }
})();
